import { MessageCircle, Info } from "lucide-react";

export default function JobOverlay({ loading, isOpen, onClickChat, onClickDetail }) {
  return (
    <div className={`
        absolute inset-0 bg-gray-900 rounded-xl transition-all duration-3000 flex items-center justify-center visible
        ${isOpen ? ' bg-opacity-60 visible backdrop-blur-sm ' : ' opacity-0 invisible '} `}>
      {/* Layer central */}
      <div className="relative z-10 rounded-xl p-6 w-full max-w-4xl mx-4">
        <div className="flex justify-center gap-4 mb-4">
          <button className="flex items-center gap-2 bg-teal-400 hover:bg-teal-300 text-black font-bold px-6 py-3 rounded-xl text-sm whitespace-nowrap"
            disabled={loading}
            onClick={onClickChat}>
            {loading ? <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-black"></div> : <MessageCircle size={16} />}
            Parler à un pro
          </button>
          <button className="flex items-center gap-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold px-6 py-3 rounded-xl text-sm whitespace-nowrap"
            onClick={onClickDetail}>
            <Info size={16} />
            En savoir +
          </button>
        </div>
        <p className="text-center text-xs text-slate-400">Tape pour fermer</p>
      </div>
    </div>
  );
}
